// --------------------------------------------------------------
// Created On: 2023-02-06
// Author: Zachary Thomas
//
// Last Modified: 2026-11-02
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import TabList from "../../../../components/TabList/TabList";
import styles from "./SystemControlTab.module.scss";
import Warning from "src/components/Warning/Warning";

// Tab for associating user groups with asset groups.
export default function SystemControlTab(props: Props): Component {
  return (
    <div>
      <div className={`${styles.body} my-4`}>
        <div className="row mx-2">
          {props.creatingNewAssetGroup ? (
            <Warning message={"System control settings cannot be modified until the asset group is created."} />
          ) : (
            <Warning
              message={
                "System control settings are managed at a different location in the app. " +
                "Use the button below to navigate to this asset group's system control."
              }
            />
          )}

          <TabList
            tabs={props.tabs}
            selectedTabId={props.tabId}
            onSelect={(tabId: string) => props.onClickTab(tabId)}
          />

          <div className={`${styles.tabsBar} py-3 text-center`}>
            <button
              data-test="assetgroup-modal-navigate-to-system-control"
              className={`${styles.navigateButton} btn btn-light my-2`}
              disabled={props.disabled || props.creatingNewAssetGroup}
              onClick={() => props.onNavigate()}
            >
              Navigate to System Control
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  tabId: string;
  tabs: ManagementTab[];
  assetgroupId: number;
  disabled: boolean;
  creatingNewAssetGroup: boolean;
  onClickTab: (tabId: string) => void;
  onNavigate: () => void;
  onError: (errorMessage: string) => void;
}

interface ManagementTab {
  tabId: string;
  name: string;
  shortName: string;
  breakPoints: string;
}
